import { env } from '../env';
import { AnalyticsBrowser } from '@segment/analytics-next';

const shouldUseAnalytics =
  env.NODE_ENV !== 'test' && Boolean(env.REACT_APP_SEGMENT_WRITE_KEY);

export const analytics = AnalyticsBrowser.load({
  writeKey: shouldUseAnalytics ? env.REACT_APP_SEGMENT_WRITE_KEY : '',
});
